import { render, staticRenderFns } from "./HelperChat.vue?vue&type=template&id=23affa22"
import script from "./HelperChat.vue?vue&type=script&lang=js"
export * from "./HelperChat.vue?vue&type=script&lang=js"
import style0 from "./HelperChat.vue?vue&type=style&index=0&id=23affa22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports